import React, { useState, useEffect } from 'react';
import { db } from '../../firebase-config';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { onSnapshot, doc, updateDoc, getDoc } from "firebase/firestore";
import { HTML5Backend } from 'react-dnd-html5-backend';
import '../../Styles/Scrumboard.css';


const ItemType = {
  CARD: 'card'
};

function ScrumBoard({isAdmin, onTaskStatusChange, selectedCompany, selectedYear, companyId}) {
    const [tasks, setTasks] = useState({
        "To-Do": [],
        "Doing": [],
        "Done": []
    });
      useEffect(() => {
            const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
            const yearDocRef = doc(db, `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`);
            const unsubscribe = onSnapshot(yearDocRef, (docSnapshot) => {
            if (!docSnapshot.exists()) {
                console.log("No data found for the selected year");
                return;
            }
            const quartersData = docSnapshot.data();
            let allAccordions = [];
    
            quarters.forEach(quarterKey => {
                allAccordions.push(...(quartersData[quarterKey] || []));
            });
    
            const newTasksState = {
                "To-Do": [],
                "Doing": [],
                "Done": []
            };
            allAccordions.forEach(accordion => {
                if (selectedCompany) {
                    newTasksState[accordion.status].push(accordion.title);
                }
            });
            setTasks(newTasksState);
        });
    
        return () => unsubscribe();
    }, [companyId, selectedYear, selectedCompany, setTasks]);
    
    const updateFirestore = async (fromColumn, toColumn, taskName) => {
        const yearDocRef = doc(db, `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`);
        const yearSnapshot = await getDoc(yearDocRef);
        if (yearSnapshot.exists()) {
            const quartersData = yearSnapshot.data();
            let updated = false;
            ['Q1', 'Q2', 'Q3', 'Q4'].forEach(quarterKey => {
                const accordions = quartersData[quarterKey] || [];
    
                accordions.forEach(accordion => {
                    if (accordion.title === taskName && (isAdmin || accordion.company === selectedCompany)) {
                        accordion.status = toColumn;
                        accordion.isFinished = toColumn === "Done";
                        updated = true;
                    }
                });
                if (updated) {
                    updateDoc(yearDocRef, { [quarterKey]: accordions });
                    onTaskStatusChange(quarterKey, taskName, toColumn === "Done");
                }
            });
        }
    };
    
    
    
    
    
    const handleDrop = async (from, to, name) => {
        await updateFirestore(from, to, name);
        const newTasks = { ...tasks };
        newTasks[from] = newTasks[from].filter(task => task !== name);
        newTasks[to].push(name);
        setTasks(newTasks);
    };
    

    return (
        <DndProvider backend={HTML5Backend}>
            <div className='scrum-board'>
                <Column classname="column" id="To-Do" title="To-Do" tasks={tasks["To-Do"]} setTasks={setTasks} isAdmin={isAdmin} handleDrop={handleDrop}  />
                <Column classname="column" id="Doing" title="Doing" tasks={tasks["Doing"]} setTasks={setTasks} isAdmin={isAdmin} handleDrop={handleDrop} />
                <Column classname="column" id="Done" title="Done" tasks={tasks["Done"]} setTasks={setTasks} isAdmin={isAdmin} handleDrop={handleDrop}/>
            </div>
        </DndProvider>
    );
}

function Column({ id, title, tasks, setTasks, isAdmin, handleDrop }) {
    const [, ref] = useDrop({
        accept: ItemType.CARD,
        drop: (item) => {
            const { from, name } = item;
            handleDrop(from, id, name);
        }
    });

    return (
        <div ref={ref} className='column'>
            <h3>{title}</h3>
            {tasks && tasks.map(task => <Card className="card" key={task} name={task} from={id} isAdmin={isAdmin}/>)}
        </div>
    );
}

function Card({ name, from, isAdmin }) {
    const [, ref] = useDrag({
        type: ItemType.CARD,
        item: { name, from },
        canDrag: isAdmin
    });

    return (
        <div ref={ref} className='card'>
            {name}
        </div>
    );
}

export default ScrumBoard;
